"use client";
import React, { useState } from 'react';
import { FAQItem } from './FAQItem';

const faqData = [
  {
    id: 1,
    question: "O que é a Nação Saúde?",
    answer: "É um movimento de saúde acessível que oferece descontos em consultas, exames, medicamentos e serviços de bem-estar, além de telemedicina 24 horas com o Einstein."
  },
  {
    id: 2,
    question: "É um plano de saúde?",
    answer: "Não. A Nação Saúde não é um plano de saúde e não possui cobertura obrigatória da ANS. É um cartão de benefícios que dá acesso a preços reduzidos em serviços médicos, exames, farmácias e telemedicina."
  },
  {
    id: 3,
    question: "Tem multa contratual?",
    answer: "Não há multa contratual. O associado pode cancelar a qualquer momento sem cobrança de taxa de cancelamento."
  },
  {
    id: 4,
    question: "Tem carência nos planos?",
    answer: "Não. A utilização dos benefícios é imediata após a adesão e pagamento da primeira mensalidade."
  },
  {
    id: 5,
    question: "Posso utilizar a rede de desconto presencial em todo país?",
    answer: "Sim. A Nação Saúde possui uma rede credenciada nacional de clínicas, laboratórios e farmácias parceiras, permitindo acesso aos descontos em diversas cidades do Brasil."
  },
  {
    id: 6,
    question: "Vou receber algum cartão físico para utilização?",
    answer: "Não é enviado cartão físico. O acesso é 100% digital, via aplicativo ou site, onde o associado encontra a carteirinha virtual para usar nos atendimentos."
  }
];

export const FAQSection = () => {
  const [expandedId, setExpandedId] = useState(1);

  const handleToggle = (id) => {
    setExpandedId(expandedId === id ? 0 : id);
  };

  return (
    <section className="d-flex flex-column align-items-center px-4 mx-auto w-100" style={{ gap: '28px', maxWidth: '800px', padding: '40px 0 40px' }}>
      <header className="w-100 text-center">
        <h1 className="fw-bold text-black mb-0" style={{ fontSize: '1.875rem' }}>
          Dúvidas Frequentes
        </h1>
      </header>
      <div className="d-flex flex-column w-100" style={{ gap: '16px' }}>
        {faqData.map((faq) => (
          <FAQItem
            key={faq.id}
            question={faq.question}
            answer={faq.answer}
            isExpanded={expandedId === faq.id}
            onToggle={() => handleToggle(faq.id)}
          />
        ))}
      </div>
    </section>
  );
};

export default FAQSection;
